export type PlanCardTier = 'free' | 'bronze' | 'silver' | 'gold';

export interface PlanCardMeta {
  tier: PlanCardTier;
  description: string;
  iconClass: string;
}

export const PLAN_CARD_META_BY_INDEX: readonly PlanCardMeta[] = [
  {
    tier: 'free',
    description: 'همه‌چیز برای شروع و آشنایی سریع با امکانات پایه سامانه.',
    iconClass: 'ic-duotone ic-ui-essentional-gift',
  },
  {
    tier: 'bronze',
    description: 'مناسب کسب‌وکارهای کوچک برای ارسال منظم و مدیریت مخاطبان.',
    iconClass: 'ic-duotone ic-like-medal-star',
  },
  {
    tier: 'silver',
    description: 'ابزارهای پیشرفته برای تیم‌هایی که به قدرت و انعطاف بیشتری نیاز دارند.',
    iconClass: 'ic-duotone ic-like-medal-ribbon-star',
  },
  {
    tier: 'gold',
    description: 'حداکثر امکانات و ظرفیت برای کسب‌وکارهای حرفه‌ای و مقیاس‌پذیر.',
    iconClass: 'ic-duotone ic-ui-essentional-crown-star',
  },
];

export function resolvePlanCardMetaByIndex(index: number): PlanCardMeta {
  return PLAN_CARD_META_BY_INDEX[index] ?? PLAN_CARD_META_BY_INDEX[0];
}
